"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  GRID_WIDTH: () => GRID_WIDTH,
  checkIntersection: () => checkIntersection,
  createDefaultRooms: () => createDefaultRooms,
  getFreePosition: () => getFreePosition,
  getFreeRoomPlace: () => getFreeRoomPlace,
  getFreeSpace: () => getFreeSpace,
  isOffice: () => isOffice,
  parseRoomName: () => parseRoomName
});
module.exports = __toCommonJS(utils_exports);
var import_core = require("@hcengineering/core");
var import_plugin = __toESM(require("./plugin"));
var import_types = require("./types");
function parseRoomName(roomName) {
  const parts = roomName.split("_");
  if (parts.length < 2) return void 0;
  const workspace = parts[0];
  const meetingId = parts[parts.length - 1];
  if (workspace === "" || meetingId === "") return void 0;
  return {
    workspace,
    meetingId
  };
}
__name(parseRoomName, "parseRoomName");
const GRID_WIDTH = 15;
function isOffice(room) {
  return room.person !== void 0;
}
__name(isOffice, "isOffice");
function createDefaultRooms(employees, defaultTranscription = false, defaultRecording = false) {
  const res = [];
  for (let index = 0; index < 12; index++) {
    const _id = (0, import_core.generateId)();
    const office = {
      _id,
      name: "",
      type: import_types.RoomType.Video,
      access: import_types.RoomAccess.Knock,
      floor: import_plugin.default.ids.MainFloor,
      width: 2,
      height: 1,
      x: index % 2 * 3,
      y: index - index % 2,
      person: employees[index] ?? null,
      language: "en",
      startWithTranscription: false,
      startWithRecording: false,
      description: null
    };
    res.push(office);
  }
  const allHands = (0, import_core.generateId)();
  res.push({
    _id: allHands,
    name: "All hands",
    type: import_types.RoomType.Video,
    access: import_types.RoomAccess.Open,
    floor: import_plugin.default.ids.MainFloor,
    width: 9,
    height: 3,
    x: 6,
    y: 0,
    language: "en",
    startWithTranscription: defaultTranscription,
    startWithRecording: defaultRecording,
    description: null
  });
  const meetingRoom1 = (0, import_core.generateId)();
  res.push({
    _id: meetingRoom1,
    name: "Meeting Room 1",
    type: import_types.RoomType.Video,
    access: import_types.RoomAccess.Open,
    floor: import_plugin.default.ids.MainFloor,
    width: 4,
    height: 3,
    x: 6,
    y: 4,
    language: "en",
    startWithTranscription: defaultTranscription,
    startWithRecording: defaultRecording,
    description: null
  });
  const meetingRoom2 = (0, import_core.generateId)();
  res.push({
    _id: meetingRoom2,
    name: "Meeting Room 2",
    type: import_types.RoomType.Video,
    access: import_types.RoomAccess.Open,
    floor: import_plugin.default.ids.MainFloor,
    width: 4,
    height: 3,
    x: 11,
    y: 4,
    language: "en",
    startWithTranscription: defaultTranscription,
    startWithRecording: defaultRecording,
    description: null
  });
  const voiceRoom1 = (0, import_core.generateId)();
  res.push({
    _id: voiceRoom1,
    name: "Voice Room 1",
    type: import_types.RoomType.Audio,
    access: import_types.RoomAccess.Open,
    floor: import_plugin.default.ids.MainFloor,
    width: 4,
    height: 3,
    x: 6,
    y: 8,
    language: "en",
    startWithTranscription: false,
    startWithRecording: false,
    description: null
  });
  const voiceRoom2 = (0, import_core.generateId)();
  res.push({
    _id: voiceRoom2,
    name: "Voice Room 2",
    type: import_types.RoomType.Audio,
    access: import_types.RoomAccess.Open,
    floor: import_plugin.default.ids.MainFloor,
    width: 4,
    height: 3,
    x: 11,
    y: 8,
    language: "en",
    startWithTranscription: false,
    startWithRecording: false,
    description: null
  });
  return res;
}
__name(createDefaultRooms, "createDefaultRooms");
const cropMaxWidth = /* @__PURE__ */ __name((width) => {
  return width > GRID_WIDTH ? GRID_WIDTH : width;
}, "cropMaxWidth");
function getFreeSpace(rooms, exclude, completeExclusion) {
  const sorted = [...rooms].sort((a, b) => a.y - b.y);
  const map = [new Array(GRID_WIDTH).fill(true)];
  for (const room of sorted) {
    const excluded = exclude?._id === room._id;
    for (let y = room.y === 0 ? 0 : excluded ? room.y : room.y - 1; y < room.y + room.height + (excluded ? 0 : 1); y++) {
      if (map[y] === void 0) {
        map[y] = new Array(GRID_WIDTH).fill(true);
      }
      for (let x = room.x === 0 ? 0 : excluded ? room.x : room.x - 1; x < (room.x + room.width - 1 < GRID_WIDTH ? excluded ? cropMaxWidth(room.x + room.width) : cropMaxWidth(room.x + room.width + 1) : GRID_WIDTH - 1); x++) {
        map[y][x] = completeExclusion === true && excluded;
      }
    }
  }
  map.push(new Array(GRID_WIDTH).fill(true));
  return map;
}
__name(getFreeSpace, "getFreeSpace");
function getFreePosition(rooms, width, height) {
  const map = getFreeSpace(rooms);
  for (let y = 0; y <= map.length; y++) {
    if (map[y] === void 0) {
      map[y] = new Array(GRID_WIDTH).fill(true);
    }
    for (let x = 0; x < map[y].length; x++) {
      if (map[y][x]) {
        let matched = true;
        for (let yIndex = 0; yIndex < height; yIndex++) {
          if (map[y + yIndex] === void 0) {
            map[y + yIndex] = new Array(GRID_WIDTH).fill(true);
          }
          for (let xIndex = 0; xIndex < width; xIndex++) {
            if (!map[y + yIndex][x + xIndex]) {
              matched = false;
              break;
            }
          }
        }
        if (matched) {
          return {
            x,
            y
          };
        }
      }
    }
  }
  return {
    x: 0,
    y: 0
  };
}
__name(getFreePosition, "getFreePosition");
function checkIntersection(rooms, width, height, x, y) {
  for (const room of rooms) {
    if (x <= room.x + room.width && x + width >= room.x && y <= room.y + room.height && y + height >= room.y) {
      return true;
    }
  }
  return false;
}
__name(checkIntersection, "checkIntersection");
function getFreeRoomPlace(room, info, person, pref) {
  let y = 0;
  if (pref !== void 0) {
    if (isOffice(room) && room.person === person) {
      return { x: 0, y: 0 };
    }
    if (!info.some((it) => it.x === pref.x && it.y === pref.y)) {
      return pref;
    }
  }
  while (true) {
    for (let x = 0; x < room.width; x++) {
      if (info.find((p) => p.x === x && p.y === y) === void 0) {
        if (x === 0 && y === 0 && isOffice(room)) {
          if (room.person === person) {
            return { x: 0, y: 0 };
          }
        } else {
          return { x, y };
        }
      }
    }
    y++;
  }
}
__name(getFreeRoomPlace, "getFreeRoomPlace");
//# sourceMappingURL=utils.js.map
